"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeContext = exports.ThemeProvider = exports.PageType = exports.MENU_FOOTER = exports.MENU_SIDE = exports.MENU_MAIN = exports.THEME_DARK = exports.THEME_LIGHT = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../utils");

var _THEMES, _MENUS;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var THEME_LIGHT = "light";
exports.THEME_LIGHT = THEME_LIGHT;
var THEME_DARK = "dark";
exports.THEME_DARK = THEME_DARK;
var MENU_MAIN = "main";
exports.MENU_MAIN = MENU_MAIN;
var MENU_SIDE = "side";
exports.MENU_SIDE = MENU_SIDE;
var MENU_FOOTER = "footer";
exports.MENU_FOOTER = MENU_FOOTER;
var THEMES = (_THEMES = {}, _defineProperty(_THEMES, THEME_LIGHT, true), _defineProperty(_THEMES, THEME_DARK, true), _THEMES);
var MENUS = (_MENUS = {}, _defineProperty(_MENUS, MENU_MAIN, true), _defineProperty(_MENUS, MENU_SIDE, true), _defineProperty(_MENUS, MENU_FOOTER, true), _MENUS);

var validateTheme = function validateTheme(theme) {
  if (theme in THEMES) {
    return theme;
  }

  return THEME_LIGHT;
};

var validatePages = function validatePages(pages) {
  if (Array.isArray(pages)) {
    return pages;
  }

  return [];
};

var validateMeta = function validateMeta(meta) {
  if ((0, _utils.isObject)(meta)) {
    return meta;
  }

  return {};
};

var validateRoot = function validateRoot(root) {
  if (typeof root === "string") {
    return root;
  }

  return "/";
};

var PageType = _propTypes.default.shape({
  id: _propTypes.default.string,
  data: _propTypes.default.shape({
    path: _propTypes.default.string,
    menu: _propTypes.default.oneOf(Object.keys(MENUS)),
    alias: _propTypes.default.string,
    title: _propTypes.default.string
  })
});

exports.PageType = PageType;

var ThemeProvider = function ThemeProvider(_ref) {
  var initialTheme = _ref.initialTheme,
      initialPages = _ref.initialPages,
      initialMeta = _ref.initialMeta,
      initialRoot = _ref.initialRoot,
      props = _objectWithoutProperties(_ref, ["initialTheme", "initialPages", "initialMeta", "initialRoot"]);

  var _useState = (0, _react.useState)(validateTheme(initialTheme)),
      _useState2 = _slicedToArray(_useState, 2),
      theme = _useState2[0],
      setTheme = _useState2[1];

  var _useState3 = (0, _react.useState)(validatePages(initialPages)),
      _useState4 = _slicedToArray(_useState3, 2),
      pages = _useState4[0],
      setPages = _useState4[1];

  var _useState5 = (0, _react.useState)(initialRoot),
      _useState6 = _slicedToArray(_useState5, 2),
      root = _useState6[0],
      setRoot = _useState6[1];

  var _useState7 = (0, _react.useState)(initialMeta),
      _useState8 = _slicedToArray(_useState7, 2),
      meta = _useState8[0],
      setMeta = _useState8[1];

  var setThemeValidated = (0, _react.useCallback)(function (theme) {
    setTheme(validateTheme(theme));
  }, []);
  var setPagesValidated = (0, _react.useCallback)(function (pages) {
    setPages(validatePages(pages));
  }, []);
  var setRootValidated = (0, _react.useCallback)(function (root) {
    setRoot(validateRoot(root));
  }, []);
  var setMetaValidated = (0, _react.useCallback)(function (meta) {
    setMeta(validateMeta(meta));
  }, []);
  var value = (0, _react.useMemo)(function () {
    return {
      meta: meta,
      root: root,
      theme: theme,
      pages: pages,
      setRoot: setRootValidated,
      setMeta: setMetaValidated,
      setPages: setPagesValidated,
      setTheme: setThemeValidated
    };
  }, [theme, pages, root, meta, setPagesValidated, setThemeValidated, setRootValidated, setMetaValidated]);
  return /*#__PURE__*/_react.default.createElement(ThemeContext.Provider, _extends({
    value: value
  }, props));
};

exports.ThemeProvider = ThemeProvider;
ThemeProvider.defaultProps = {
  initialMeta: {},
  initialRoot: "/",
  initialPages: [],
  initialTheme: THEME_LIGHT
};
ThemeProvider.propTypes = {
  initialRoot: _propTypes.default.string,
  initialMeta: _propTypes.default.shape({
    company: _propTypes.default.string.isRequired,
    page: _propTypes.default.string.isRequired
  }).isRequired,
  initialPages: _propTypes.default.arrayOf(PageType),
  initialTheme: _propTypes.default.oneOf(Object.keys(THEMES))
};
var ThemeContext = /*#__PURE__*/(0, _react.createContext)();
exports.ThemeContext = ThemeContext;